module.exports = __webpack_public_path__ + "img/location.4c0719e7.svg";